import { AbstractModel } from './abstract-model';
import { Category } from './category';
import { OfferType } from './offer-type';
import { Location } from './locations';

export interface LocationSuggestion {
  id: string;
  name: string;
  plz: string;
}

export interface OfferWithImageHTTPResponse {
  id: string;
  name: string;
  description: string;
  companyId: number;
  categories: Category[];
  imageUrl: string;
  status: string;
  offerType: OfferType;
  appointmentDateTime: string;
  videoEmbeddedLink: string;
  updated: number;
  orte: Location[];
  bezirke: { id: number; name: string }[];
  bundeslaender: { id: number; name: string }[];
  allAustria?: boolean;
}

export class OfferWithImage implements AbstractModel {
  id: string;
  name: string;
  description: string;
  companyId: number;
  categories: Category[];
  imageUrl: string;
  status: string;
  offerType: OfferType;
  appointmentDateTime: Date;
  videoEmbeddedLink: string;
  updated: number;
  orte: Location[];
  bezirke: { id: number; name: string }[];
  bundeslaender: { id: number; name: string }[];
  allAustria: boolean;

  constructor(data: {
    id: string;
    name: string;
    description: string;
    companyId: number;
    categories: Category[];
    imageUrl: string;
    status: string;
    offerType: OfferType;
    appointmentDateTime?: string;
    videoEmbeddedLink: string;
    updated: number;
    orte?: Location[];
    bezirke?: { id: number; name: string }[];
    bundeslaender?: { id: number; name: string }[];
    allAustria?: boolean;
  }) {
    this.id = data.id;
    this.name = data.name;
    this.description = data.description;
    this.companyId = data.companyId;
    this.categories = data.categories;
    this.imageUrl = data.imageUrl;
    this.status = data.status;
    this.offerType = data.offerType;
    this.appointmentDateTime = data.appointmentDateTime
      ? new Date(data.appointmentDateTime)
      : new Date();
    this.videoEmbeddedLink = data.videoEmbeddedLink;
    this.updated = data.updated;
    this.orte = data.orte || [];
    this.bezirke = data.bezirke || [];
    this.bundeslaender = data.bundeslaender || [];
    this.allAustria = data.allAustria || false;
  }

  static fromHTTPResponse(
    response: OfferWithImageHTTPResponse
  ): OfferWithImage {
    return new OfferWithImage({
      ...response,
    });
  }

  get updatedDate(): Date {
    return new Date(this.updated * 1000);
  }

  get appointmentDate(): Date {
    return new Date(this.appointmentDateTime);
  }

  get appointmentTimeHours(): number {
    return this.appointmentDate.getHours();
  }

  get appointmentTimeMinutes(): number {
    return this.appointmentDate.getMinutes();
  }
}
